module.exports = __webpack_public_path__ + "static/media/fa-light-300.25ea1f58.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-light-300.woff2
// module id = 733
// module chunks = 0